export const propertiesData = [
  {
    id: 1,
    category: 'terreno',
    title: 'Lote Premium Norte',
    location: 'Nordelta, Buenos Aires',
    price: 'USD 120,000',
    image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=800&auto=format&fit=crop',
    badgeType: 'terreno',
    badgeText: 'Terreno',
    description: 'Lote premium en el corazón de Nordelta, con acceso a todos los servicios, calles asfaltadas y alumbrado público. Ideal para construcción de vivienda única o proyecto inmobiliario.',
    features: [
      { icon: 'maximize', text: '800 m²', detail: 'Superficie total' },
      { icon: 'check-circle', text: 'Escritura', detail: 'Título de propiedad' },
      { icon: 'ruler', text: '20x40m', detail: 'Medidas del terreno' },
      { icon: 'zap', text: 'Servicios', detail: 'Luz, agua, gas' },
      { icon: 'shield', text: 'Barrio privado', detail: 'Seguridad 24/7' },
      { icon: 'leaf', text: 'Árboles', detail: 'Paisajismo natural' } // Cambiado tree por leaf
    ],
    images: [
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1572120360610-d971b9d7767c?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1568605114967-8130f3a36994?q=80&w=800&auto=format&fit=crop'
    ],
    amenities: ['Acceso asfaltado', 'Alumbrado público', 'Cloacas', 'Gas natural', 'Agua corriente', 'Seguridad 24/7'],
    status: 'Disponible',
    year: '2024',
    address: 'Av. de los Lagos 1234, Nordelta',
    contactPerson: 'Juan Pérez',
    contactPhone: '+54 11 1234-5678'
  },
  {
    id: 2,
    category: 'casa',
    title: 'Casa Minimalista',
    location: 'Pilar, Buenos Aires',
    price: 'USD 350,000',
    image: 'https://images.unsplash.com/photo-1600596542815-2495db9a9cf6?q=80&w=800&auto=format&fit=crop',
    badgeType: 'destacado',
    badgeText: 'Destacado',
    description: 'Moderno diseño minimalista con amplios espacios y excelente iluminación natural. Construida con materiales de primera calidad, cuenta con piscina y parque privado.',
    features: [
      { icon: 'bed', text: '4', detail: 'Dormitorios' },
      { icon: 'bath', text: '3', detail: 'Baños' },
      { icon: 'maximize', text: '280 m²', detail: 'Superficie cubierta' },
      { icon: 'home', text: '450 m²', detail: 'Superficie total' },
      { icon: 'car', text: '2', detail: 'Cocheras' },
      { icon: 'layers', text: '2', detail: 'Plantas' }
    ],
    images: [
      'https://images.unsplash.com/photo-1600596542815-2495db9a9cf6?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1600573472550-8090b5e0745c?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1600566752355-35792bedcfea?q=80&w=800&auto=format&fit=crop'
    ],
    amenities: ['Piscina', 'Parque', 'Quincho', 'Cocina integrada', 'Closet vestidor', 'Calefacción central', 'Aire acondicionado'],
    status: 'Venta',
    year: '2022',
    address: 'Calle Los Alamos 567, Pilar',
    contactPerson: 'María González',
    contactPhone: '+54 11 2345-6789'
  },
  {
    id: 3,
    category: 'departamento',
    title: 'Loft en Palermo',
    location: 'Palermo, CABA',
    price: 'USD 180,000',
    image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=800&auto=format&fit=crop',
    badgeType: 'depto',
    badgeText: 'Depto',
    description: 'Loft luminoso con diseño industrial, ubicado en el corazón de Palermo. Espacio único con doble altura, excelente conectividad y cerca de restaurantes y bares de moda.',
    features: [
      { icon: 'bed', text: '2', detail: 'Dormitorios' },
      { icon: 'bath', text: '2', detail: 'Baños' },
      { icon: 'car', text: '1', detail: 'Cochera' },
      { icon: 'building', text: '8°', detail: 'Piso' },
      { icon: 'maximize', text: '85 m²', detail: 'Superficie' },
      { icon: 'sun', text: 'Norte', detail: 'Orientación' }
    ],
    images: [
      'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=800&auto=format&fit=crop'
    ],
    amenities: ['Ascensor', 'Seguridad 24h', 'Laundry', 'Gimnasio', 'Sum', 'Terraza', 'Balcón'],
    status: 'Venta',
    year: '2023',
    address: 'Av. Santa Fe 1234, Palermo',
    contactPerson: 'Carlos Rodríguez',
    contactPhone: '+54 11 3456-7890'
  },
  {
    id: 4,
    category: 'alquiler',
    title: 'Piso en Recoleta',
    location: 'Recoleta, CABA',
    price: 'USD 800',
    rental: true,
    image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=800&auto=format&fit=crop',
    badgeType: 'alquiler',
    badgeText: 'Alquiler',
    description: 'Encantador departamento en edificio histórico de Recoleta, con detalles originales restaurados y todas las comodidades modernas. Excelente ubicación cerca de museos y restaurantes.',
    features: [
      { icon: 'bed', text: '1', detail: 'Dormitorio' },
      { icon: 'bath', text: '1', detail: 'Baño' },
      { icon: 'building', text: 'Piso 8', detail: 'Edificio histórico' },
      { icon: 'maximize', text: '65 m²', detail: 'Superficie' },
      { icon: 'sun', text: 'Balcón', detail: 'Vista a la calle' },
      { icon: 'box', text: 'Amoblado', detail: 'Mobiliario completo' }
    ],
    images: [
      'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502672024261-5a2c36b1a8e2?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502672012124-7db6b0a9b0e9?q=80&w=800&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1502672024261-5a2c36b1a8e2?q=80&w=800&auto=format&fit=crop'
    ],
    amenities: ['Amoblado', 'Cochera', 'Ascensor', 'Seguridad', 'Calefacción', 'Aire acondicionado', 'Lavadero'],
    status: 'Alquiler',
    year: '1920 (remodelado 2022)',
    address: 'Av. Alvear 567, Recoleta',
    contactPerson: 'Ana Martínez',
    contactPhone: '+54 11 4567-8901',
    contractDetails: {
      deposit: '2 meses',
      duration: '2 años mínimo',
      expenses: 'A cargo del inquilino'
    }
  }
];